import moment from "moment";

/** parse object to json */
export function dataToJson(data) {
  if (!data) {
    return data;
  }
  return JSON.parse(JSON.stringify(data));
}

/** notify 약자 타입에서 full name을 반환 */
function get_notify_type(type) {
  switch (type) {
    case "s":
      type = "success";
      break;
    case "w":
      type = "warning";
      break;
    case "i":
      type = "info";
      break;
    case "e":
      type = "error";
      break;
    default:
      type = "";
  }
  return type;
}

/** return notify message */
export function get_notify_options(type, title, message) {
  type = get_notify_type(type);
  return {
    title: title,
    type: type,
    message: message,
  };
}

/** 오류 팝업 */
export function notify_error(self, title, message) {
  const options = get_notify_options("e", title, message);
  self.$notify(options);
}

/** BE 오류 메시지 알림  */
export function notify_response_error(self, title, res) {
  const options = get_response_error(self, title, res);
  self.$notify(options);
}

/** BE 오류 메시지 옵션 반환  */
export function get_response_error(self, title, res) {
  let message = res.message;
  if (res.error !== 1) {
    message = self.$t("error." + res.error);
  }
  if (res.data) {
    message += JSON.stringify(res.data);
  }
  const options = get_notify_options("e", title, message);
  return options;
}

/** 성공 팝업 */
export function notify_success(self, title, message) {
  const options = get_notify_options("s", title, message);
  self.$notify(options);
}

/** 경고 팝업 */
export function notify_warning(self, title, message) {
  const options = get_notify_options("w", title, message);
  self.$notify(options);
}

export function notify(self, type, title, message) {
  let options = type;
  if (typeof type === "string") {
    options = get_notify_options(type, title, message);
  }
  self.$notify(options);
}

/** 삭제 여부를 몯는 컨펌창 팝업 */
export function confirm(self, title, message, callback, cancelCallback) {
  return self
    .$confirm(message, title, {
      type: "warning",
      confirmButtonText: "네",
      cancelButtonText: "아니오",
    })
    .then(() => {
      callback();
    })
    .catch(() => {
      if (cancelCallback) {
        cancelCallback();
      }
    });
}

/** 삭제 여부를 몯는 컨펌창 팝업 */
export function confirm_delete(self, title, callback, message) {
  if (!message) {
    message = "삭제하시겠습니까?";
  }
  return self
    .$confirm(message, title, {
      type: "warning",
      confirmButtonText: "네",
      cancelButtonText: "아니오",
    })
    .then(() => {
      callback();
    })
    .catch(() => {});
}

/** 저장되지 않은 데이타가 삭제 여부를 묻는 컨펌창 팝업 */
export function confirm_leave(self, title, leaveCallback, message) {
  if (!message) {
    message = "변경사항이 저장되지 않을 수 있습니다. 나가시겠습니까?";
  }
  self
    .$confirm(message, title, {
      dangerouslyUseHTMLString: true,
      confirmButtonText: "나가기",
      cancelButtonText: "취소",
      type: "warning",
    })
    .then(() => {
      leaveCallback();
    })
    .catch(() => {
      return false;
    });
}

export function alert(self, title, message) {
  self.$alert(message, title);
}

/** 텍스트 전체에서 - 제거 */
export function remove_dash(value) {
  if (!value) {
    return value;
  }
  return value.replace(/-/gi, "");
}

/** timestamp에서 날짜를 반환합니다. */
export function castDate(timestamp) {
  let date = this.moment(timestamp);
  return date;
}

/** 날짜를 반환 */
export function getDate(days) {
  let date = moment();
  if (days !== undefined) {
    date = date.add(days, "days");
  }
  return moment(date).format("YYYY-MM-DD");
}

/**
 * 기간에 대한 Date 객체를 timestamp로 변환한다.
 */
export function getTime(date, isEndTime = false) {
  let value = date;
  if (!isEndTime) {
    value.setHours(0);
    value.setMinutes(0);
    value.setSeconds(0);
    value.setMilliseconds(0);
  } else {
    value.setHours(23);
    value.setMinutes(59);
    value.setSeconds(59);
    value.setMilliseconds(999);
  }
  return value.getTime();
}

export function getDateString(date, exceptTime = true) {
  let format = exceptTime ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm:ssZ";
  return moment(date).format(format);
}

export function addPeriod(period, interval, convert = true) {
  var time = moment().add(period, interval);
  return convert ? time.format("YYYY-MM-DD") : time;
}

export function addDays(date, days) {
  return moment(date)
    .add(days, "days")
    .format("YYYY-MM-DD");
}

/** 기간에 대한 문자열 반환 */
export function getPeriodText(period) {
  let name;
  if (typeof period === "object") {
    const value = period.value;
    name =
      castDate(value.start).toISOString() +
      " ~ " +
      castDate(value.end).toISOString();
  } else {
    const value = period.substring(0, period.length - 1);
    let interval = period.substring(period.length - 1, period.length);
    switch (interval) {
      case "w":
        interval = "주";
        break;
      case "m":
        interval = "개월";
        break;
    }
    name = value + interval;
  }
  return name;
}

/** 배열에서 다중 필드에 대한 검색 결과를 반환 */
export function filterMultiFields(
  array,
  search_fields,
  searchWord,
  foreign_flag
) {
  let word = searchWord ? searchWord.trim().toLowerCase() : "";
  let fields = search_fields;
  let copied_array = [...array];
  if (!Array.isArray(fields)) {
    fields = [search_fields];
  }
  if (foreign_flag) {
    copied_array = copied_array.filter(
      (value) => value.foreign_flag === foreign_flag
    );
  }
  if (word.length < 1 || fields.length < 1) {
    return copied_array;
  }
  return copied_array.filter((item) => {
    let values = [];
    fields.forEach((field) => {
      if (item[field]) {
        values.push(item[field].toString().toLowerCase());
      }
    });
    return values.some((value) => value.indexOf(word) > -1);
  });
}

/** 숫자에 콤마를 붙여서 표시 */
export function numberWComma(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function clone(obj) {
  let type = typeof obj;
  if (!obj) {
    return obj;
  } else if (Array.isArray(obj)) {
    let a = [];
    obj.forEach((o) => {
      a.push(this.clone(o));
    });
    return a;
  } else if (type === "object") {
    let c = {};
    Object.keys(obj).forEach((key) => {
      if (!obj[key]) {
        c[key] = obj[key];
      } else {
        if (Array.isArray(obj[key])) {
          c[key] = this.clone(obj[key]);
        } else {
          switch (typeof obj[key]) {
            case "object":
              c[key] = this.clone(obj[key]);
              break;
            default:
              c[key] = obj[key];
              break;
          }
        }
      }
    });
    return c;
  } else {
    return obj;
  }
}

export function copyObject(src, dest) {
  for (let key in src) {
    dest[key] = clone(src[key]); // copies each property to the objCopy object
  }
}

export function looseClone(obj) {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj;
}

/** column formatter 숫자에 콤마를 붙여서 표시 */
export function numberFormat(row, column, cellValue) {
  if (cellValue === null || cellValue === undefined) {
    return "";
  }
  if (!cellValue) {
    return "0";
  }
  return addComma(cellValue);
}

export function addComma(val) {
  if (val == 0) {
    return 0;
  }
  if (!val) {
    return "";
  }
  val += "";
  if (val % 1 !== 0) {
    val = Number.parseFloat(val).toFixed(1);
  }
  if (!val.includes(".")) val += ".";
  return val
    .replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
      return $1 + ",";
    })
    .replace(/\.$/, "");
}

export function removeComma(val) {
  if (typeof val !== "string") {
    return val;
  }
  const n = parseInt(val.replace(/,/g, ""));
  return n;
}

export function removeFloatComma(val) {
  if (typeof val !== "string") {
    return val;
  }
  const n = parseFloat(val.replace(/,/g, ""));
  return n;
}

/** column formatter 날짜 yyyy-MM-dd */
export function dateFormat(row, column, cellValue) {
  let m = moment(cellValue);
  if (m.isValid()) {
    return m.format("YYYY-MM-DD");
  }
  return cellValue;
}

/** column formatter 날짜 YYYY-MM-DD HH:mm:ss */
export function dateTimeFormat(row, column, cellValue) {
  let m = moment(cellValue);
  if (m.isValid()) {
    return m.format("YYYY-MM-DD HH:mm:ss");
  }
  return cellValue;
}

/** column formatter 사용 */
export function useFormat(row, column, cellValue) {
  return cellValue === "Y" ? "사용" : "미사용";
}

/** (일짜 + 24시간) 현재시간 초과여부 판단 */
export function isLessThan24h(value) {
  let m = moment(value);
  if (m.isValid()) {
    m = m.add(1, "days");
    return moment() < m;
  }
  return false;
}

export function sortByName(a, b) {
  if (a.name !== b.name) {
    return a.name > b.name ? 1 : -1;
  }
  return 0;
}

export function sortDescByName(a, b) {
  if (a.name !== b.name) {
    return a.name > b.name ? -1 : 1;
  }
  return 0;
}

var compareSort = function(a, b) {
  if (!a && !b) {
    return false;
  } else if (!a || !b) {
    return !!a;
  } else {
    return a < b;
  }
};

var partitionAscending = function(array, prop, left, right, pivotIndex) {
  // 정렬하는 부분
  var temp;
  var pivot = array[pivotIndex][prop];
  while (left <= right) {
    // 왼쪽, 오른쪽 수를 규칙과 비교해 다음 수로 넘어갑니다.
    while (left <= array.length && compareSort(array[left][prop], pivot)) {
      left++;
    }
    while (right >= 0 && compareSort(pivot, array[right][prop])) {
      right--;
    }
    if (left <= right) {
      // 왼쪽이 기준보다 크고, 오른쪽이 기준보다 작으면
      temp = array[left];
      array[left] = array[right];
      array[right] = temp; // 서로 바꿔줍니다.
      left++;
      right--;
    }
  }
  temp = array[left];
  array[left] = array[pivotIndex];
  array[pivotIndex] = temp; // 마지막으로 기준과 만난 수를 바꿔줍니다. 기준의 위치는 이제 i입니다.
  return left;
};

var partitionDescending = function(array, prop, left, right, pivotIndex) {
  // 정렬하는 부분
  var temp;
  var pivot = array[pivotIndex][prop];
  while (left <= right) {
    // 왼쪽, 오른쪽 수를 규칙과 비교해 다음 수로 넘어갑니다.
    while (left <= array.length && compareSort(pivot, array[left][prop])) {
      left++;
    }
    while (right >= 0 && compareSort(array[right][prop], pivot)) {
      right--;
    }
    if (left <= right) {
      // 왼쪽이 기준보다 크고, 오른쪽이 기준보다 작으면
      temp = array[left];
      array[left] = array[right];
      array[right] = temp; // 서로 바꿔줍니다.
      left++;
      right--;
    }
  }
  temp = array[left];
  array[left] = array[pivotIndex];
  array[pivotIndex] = temp; // 마지막으로 기준과 만난 수를 바꿔줍니다. 기준의 위치는 이제 i입니다.
  return left;
};

var qSort = function(array, prop, ascending, left, right) {
  // 재귀하는 부분
  if (!left) left = 0;
  if (!right) right = array.length - 1;
  var pivotIndex = right; // 배열 가장 오른쪽의 수를 기준으로 뽑습니다.
  if (ascending) {
    pivotIndex = partitionAscending(array, prop, left, right - 1, pivotIndex); // right - 1을 하는 이유는 기준(현재 right)을 제외하고 정렬하기 위함입니다.
  } else {
    pivotIndex = partitionDescending(array, prop, left, right - 1, pivotIndex); // right - 1을 하는 이유는 기준(현재 right)을 제외하고 정렬하기 위함입니다.
  }
  if (left < pivotIndex - 1)
    qSort(array, prop, ascending, left, pivotIndex - 1); // 기준 왼쪽 부분 재귀
  if (pivotIndex + 1 < right)
    qSort(array, prop, ascending, pivotIndex + 1, right); // 기준 오른쪽 부분 재귀
  return array;
};

export function quickSort(array, prop, ascending = true) {
  let arItem = array.filter((a) => a[prop]);
  if (arItem.length < 1) {
    return array;
  }
  let arNull = array.filter((a) => !a[prop]);
  let arSorted = qSort(arItem, prop, ascending);
  return arSorted.concat(arNull);
}

export function getCustomerAddress(customer) {
  if (!customer) {
    return "";
  }
  let ret = "";
  if (customer.delivery_addr_flag === "2") {
    ret = customer.addr2;
  } else {
    ret = customer.addr;
  }
  return ret;
}

export function getCustomerZipcode(customer) {
  if (!customer) {
    return "";
  }
  if (customer.delivery_addr_flag === "2") {
    return customer.zipcode2;
  } else {
    return customer.zipcode;
  }
}

export function isPastDate(date) {
  let today = this.getDate();
  return date < today;
}

export function calculateSize(value, product) {
  let size = { door: 0, rail: 0, belt: 0 };
  if (!value) {
    return size;
  }
  let door2 = product.categories.find((c) => c.product_category_id === 2);
  let is2Door = door2 ? true : false;
  let arSize = value
    .toUpperCase()
    .trim()
    .split(" ");
  value = arSize[arSize.length - 1];
  if (value.startsWith("D")) {
    size.door = Number.parseInt(value.replace("D", ""));
    if (size.door) {
      size.rail = is2Door ? size.door * 4 - 150 : size.door * 2 - 100;
    }
  } else if (value && value !== "0") {
    size.rail = Number.parseInt(value.replace("R", ""));
    if (size.rail) {
      size.door = is2Door ? (size.rail + 150) / 4 : (size.rail + 100) / 2;
    }
  }
  if (size.rail) {
    size.belt = is2Door ? size.rail * 2 - 1400 : size.rail * 2 - 700;
  }
  return size;
}

export function getSpecification(detail, details) {
  let specifications = details.filter(
    (d) => d.specification && d.specification.includes(detail.seq)
  );
  let result = "";
  specifications.forEach((s) => {
    if (result !== "") {
      result += ", ";
    }
    result += s.product_name + ": " + s.per_amount + s.unit_name;
  });
  return result;
}

export function resolveSeq(data) {
  return data.option_id ? "*" : data.seq;
}

export function calculatePyung(horizontal, vertical, fixed = false) {
  if (typeof vertical === "string" && vertical.includes("/"))
    vertical = vertical.split("/")[0];
  let ret = (horizontal * vertical) / 90000;
  return fixed ? Math.round(ret * 100) / 100 : ret;
}

export function fireResize() {
  var evt = document.createEvent("HTMLEvents");
  evt.initEvent("resize", true, false);
  window.dispatchEvent(evt);
}

export function getAddressByDeliveryWay(delivery_way_flag, customer) {
  if (!customer) {
    return null;
  }
  let flag = delivery_way_flag.substring(0, 1);
  // 앞 자리가 1인지
  if (flag !== "1") {
    return null;
  }
  flag = delivery_way_flag.substring(1);
  // 뒷자리로 주소 선택 반환
  if (!["1", "2"].includes(flag)) {
    return null;
  }
  if (flag === "2") {
    return {
      zipcode: customer.zipcode2,
      addr: customer.addr2,
    };
  } else {
    return {
      zipcode: customer.zipcode,
      addr: customer.addr,
    };
  }
}
export function getGoodSize(size, product) {
  let door2 = product.categories.find((c) => c.product_category_id === 2);
  let is2Door = door2 ? true : false;
  size = size.toUpperCase().trim();
  let rail_size = "";
  let door_size = "";
  let belt_size = "";
  if (size.startsWith("D")) {
    door_size = Number.parseInt(size.replace("D", ""));
    if (door_size) {
      rail_size = is2Door ? door_size * 4 - 150 : door_size * 2 - 100;
    }
  } else if (size && size !== "0") {
    rail_size = Number.parseInt(size.replace("R", ""));
    if (rail_size) {
      door_size = is2Door ? (rail_size + 150) / 4 : (rail_size + 100) / 2;
    }
  } else {
    rail_size = 0;
    door_size = 0;
  }
  if (rail_size) {
    belt_size = is2Door ? rail_size * 2 - 1400 : rail_size * 2 - 700;
  } else {
    belt_size = 0;
  }
  return {
    rail_size: rail_size,
    door_size: door_size,
    belt_size: belt_size,
  };
}
export function getGoodsSerialCode(item) {
  let code_list = [];
  if (item.goods === undefined || !item.goods || item.goods.length < 1) {
    return "";
  }
  item.goods.forEach((good_item) => {
    code_list.push(Number(good_item.code.slice(-7, -3)));
  });
  code_list.sort(function(a, b) {
    return a - b;
  });
  if (code_list.length == 1) {
    return code_list[0];
  } else if (code_list.length > 1) {
    return code_list[0] + "-" + code_list[code_list.length - 1];
  }
}

export function deepClone(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  const result = Array.isArray(obj) ? [] : {};
  for (const key of Object.keys(obj)) {
    result[key] = this.deepClone(obj[key]);
  }
  return result;
}
